module.exports = __webpack_public_path__ + "static/img/解决方案-化工解决方案-case.f581d8ec.png";